import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import KapalService from "../../services/master/KapalService.js";
import SweetAlert from "react-bootstrap-sweetalert";

const AddPelabuhanModal = ({ show, onHide, onSuccess }) => {
  const [formData, setFormData] = useState({
    kode_pelabuhan: "",
    nama_pelabuhan: "",
    koordinat: "",
    kode_propinsi: "",
    lokasi_pelabuhan: "",
    jenis_pelabuhan: "",
  });

  const [propinsi, setPropinsi] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingPropinsi, setLoadingPropinsi] = useState(true);
  const [showSendSuccess, setShowSendSuccess] = useState(false);
  const [showSendFailed, setShowSendFailed] = useState(false);

  useEffect(() => {
    const fetchPropinsi = async () => {
      try {
        setLoadingPropinsi(true);
        const res = await KapalService.getPropinsi();
        if (Array.isArray(res)) {
          setPropinsi(res);
        } else if (Array.isArray(res.data)) {
          setPropinsi(res.data);
        }
      } catch (err) {
        console.error("Gagal mengambil data propinsi:", err);
      } finally {
        setLoadingPropinsi(false);
      }
    };

    fetchPropinsi();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await KapalService.createPelabuhan(formData);
      setShowSendSuccess(true);
      onSuccess();
      onHide();
    } catch (error) {
      console.error("❌ Gagal menambahkan pelabuhan:", error);
      setShowSendFailed(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal show={show} onHide={onHide} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Tambah Pelabuhan Pendaratan</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Kode Pelabuhan</Form.Label>
              <Form.Control
                type="text"
                name="kode_pelabuhan"
                value={formData.kode_pelabuhan}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Nama Pelabuhan</Form.Label>
              <Form.Control
                type="text"
                name="nama_pelabuhan"
                value={formData.nama_pelabuhan}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Koordinat</Form.Label>
              <Form.Control
                type="text"
                name="koordinat"
                value={formData.koordinat}
                onChange={handleChange}
                placeholder="contoh: -6.200, 106.816"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Provinsi</Form.Label>
              {loadingPropinsi ? (
                <div className="text-muted">
                  <Spinner animation="border" size="sm" /> Memuat data provinsi...
                </div>
              ) : (
                <Form.Select
                  name="kode_propinsi"
                  value={formData.kode_propinsi}
                  onChange={handleChange}
                  required
                >
                  <option value="">-- Pilih Provinsi --</option>
                  {propinsi.map((item) => (
                    <option key={item.KODE_PROPINSI} value={item.KODE_PROPINSI}>
                      {item.URAIAN_PROPINSI}
                    </option>
                  ))}
                </Form.Select>
              )}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Lokasi Pelabuhan</Form.Label>
              <Form.Control
                type="text"
                name="lokasi_pelabuhan"
                value={formData.lokasi_pelabuhan}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Jenis Pelabuhan</Form.Label>
              <Form.Control
                type="text"
                name="jenis_pelabuhan"
                value={formData.jenis_pelabuhan}
                onChange={handleChange}
                placeholder="contoh: PPN, PPS, PP, CP"
              />
            </Form.Group>

            <div className="d-flex justify-content-end mt-4">
              <Button variant="secondary" onClick={onHide} className="me-2">
                Batal
              </Button>
              <Button type="submit" variant="primary" disabled={loading}>
                {loading ? (
                  <>
                    <Spinner animation="border" size="sm" /> Simpan...
                  </>
                ) : (
                  "Simpan"
                )}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {showSendSuccess && (
        <SweetAlert
          success
          title="Berhasil!"
          onConfirm={() => setShowSendSuccess(false)}
          confirmBtnText="OK"
        >
          Data pelabuhan berhasil ditambahkan.
        </SweetAlert>
      )}

      {showSendFailed && (
        <SweetAlert
          danger
          title="Gagal!"
          onConfirm={() => setShowSendFailed(false)}
          confirmBtnText="Tutup"
          timeout={4000}
        >
          Gagal menambahkan pelabuhan. Silakan coba lagi.
        </SweetAlert>
      )}
    </>
  );
};

export default AddPelabuhanModal;
